// extracted by mini-css-extract-plugin
export default {"sectionTitle":"Profile_sectionTitle__QTixv","kidsEditForm":"Profile_kidsEditForm__ZC2RQ","kidItemHeade":"Profile_kidItemHeade__OUtsW"};